module.exports = __webpack_public_path__ + "static/nunuma-a6c3b9cbb469cc927031788f02c7018d.webp";